<template>
    <div>
        <!--Header Components-->
        <base-header class="mt-4 pb-6" type=""/>
        <b-container fluid class="mt--6">
          <div>
              <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
          </div>
          <b-row>
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <div slot="header" class="mb-0">
                    <b-row>
                      <b-col cols="8">
                          <h3>{{language_terms['CREDIT_NOTES']}}</h3>
                      </b-col>
                      <b-col cols="4">
                         <base-button type="success" @click="addNew" class="float-right">
                            <i class="fa fa-plus"></i>
                          </base-button>
                      </b-col>
                    </b-row>
                  </div>
                  <b-row>
                    <b-col md="3" >
                      <base-input :label="language_terms['VENDOR']" v-model="filter.contact_name" v-on:keyup.enter="clickOnSearch">
                      </base-input>
                    </b-col>
                    <b-col md="2" >
                      <base-input :label="language_terms['DOC_#']" v-model="filter.invoice_code" v-on:keyup.enter="clickOnSearch">
                      </base-input>
                    </b-col>
                    <b-col md="2" >
                      <base-input :label="language_terms['DATE_FROM']">
                        <flat-picker slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker" v-model="filter.from_date">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col md="2">
                      <base-input :label="language_terms['DATE_TO']">
                        <flat-picker slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" style="background-color: white;" class="form-control datepicker" v-model="filter.to_date">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col md="2">
                      <base-input :label="language_terms['STATUS']">
                        <el-select v-model="filter.status" filterable>
                          <el-option v-for="option in status_options"
                                    :key="option.value"
                                    :label="option.label"
                                    :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                    <b-col cols="1" class="mt-4">
                      <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                    </b-col>
                  </b-row>
                </card>
                <!-- Search Results -->
                <!-- zehua -->
                <b-row v-if="filter.items.length > 0">
                  <b-col lg="12">
                    <div class="card-wrapper">
                      <card>
                        <div slot="header" class="mb-0">
                          <b-row>
                            <b-col lg="11">
                                <h3>Search Results</h3>
                            </b-col>
                          </b-row>
                        </div>
                        <b-row class="mt--4">
                          <b-col cols="12" class="mt-3">
                            <b-table-simple hover responsive>
                                <b-thead head-variant="light">
                                    <b-th>{{language_terms['DOC_#']}}</b-th>
                                    <b-th>{{language_terms['VENDOR']}}</b-th>
                                    <b-th>{{language_terms['DATE']}}</b-th>
                                    <b-th>{{language_terms['CURRENCY']}}</b-th>
                                    <b-th>{{language_terms['AMOUNT']}}</b-th>
                                    <b-th>{{language_terms['REFERENCE']}} </b-th>
                                    <b-th>{{language_terms['STATUS']}} </b-th>
                                </b-thead>
                                <b-tbody> 
                                    <tr v-for="(item, i) in filter.items" :key="i" @click="onClickReceipt(item)">
                                        <td>{{item.code}}</td>
                                        <td>{{item.contact_name}}</td>
                                        <td>{{item.date}}</td>
                                        <td>{{item.currency_code}}</td>
                                        <td>{{(item.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                        <td>{{item.reference}}</td>
                                        <td>{{item.status}}</td>
                                    </tr>
                                </b-tbody>
                            </b-table-simple>
                          </b-col>
                        </b-row>                            
                      </card>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-container>
    </div>
  </template>
  <script>
  import { authHeader } from "../../../global";
  import { apiRoutes } from "../../../apiRoutes";
  import axios from "axios";
  import { Select, Option } from 'element-ui'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';  
  import { mapState } from "vuex";
  
  export default {
    components:{
      Loading,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
    },
    computed:{
        ...mapState({
          sales_filter:state => state.sales.filter,
          sales_quotations: state => state.sales.sales_quotations,
          sales_orders: state => state.sales.sales_orders,
          sales_invoices: state => state.sales.sales_invoices,
          dos: state => state.dos.dos,
          language_terms: state => state.languages.language_terms,
          selected_lang: state => state.languages.selected_langauge,
  
        }),
      },
    watch:{

    },
    async mounted()
    {

    },

    data(){
      return{
        loadingCounter:0,
        fullPage:true,
        filter:{
          mode:'CN',
          invoice_code:"",
          contact_name: null,
          keyword:"",
          product:"",
          from_date:null,
          to_date:null,
          type:null,
          status:'ALL',
          items: []
        },
        items:[],
        status_options:[
          {
            label:"All",
            value:"ALL"
          },
          {
            label:"Open",
            value: null
          },
          {
            label:"Posted",
            value:"1"
          },
          {
            label:"Cancelled",
            value:"0"
          },
        ],
      }
    },
  
    methods:{
      async onClickReceipt(item)
      {
        if(item)
        {
          this.loadingCounter++
          let payload = {code:item.code, mode:'CN'}
          await axios
          .post(apiRoutes["AP_RETRIEVE"], payload, authHeader())
          .then((response) => 
          {
            if (response.data.code == 1) {
              this.$router.push("/finance/ap-credit-note/" +  encodeURIComponent(item.code));          
            } 
            else 
            {
              alert('Failed');
            }

          })
          .catch((error) => {
            if (error.response) {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
          });
          
          this.loadingCounter--
        }
      },
      updateTableLang(){
      },
      async clickOnSearch(){
        this.filter.type = this.type
        this.filter.limit = ''

        this.loadingCounter++

        this.filter.limit = ''
        let payload = this.filter
            
        await axios
        .post(apiRoutes["AP_QUICK_SEARCH"], payload, authHeader())
        .then((response) => 
        {
          if (response.data.code == 1) {
            this.filter.items = response.data.data
          } 
          else 
          {
            alert('Failed');
          }
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
        this.loadingCounter--
      },
      async addNew()
      {
        let url = '/finance/ap-credit-note/_new'
        this.$router.push(url)
      }
    }
  }
  </script>
  